
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import wellKnownSymbol$1 from './well-known-symbol.js';

var wellKnownSymbol = wellKnownSymbol$1;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

export { toStringTagSupport as default };
//# sourceMappingURL=to-string-tag-support.js.map
